import { z } from "zod";

export const DerivedDocumentStateSchema = z.enum([
  "pending",
  "processing",
  "ready",
  "failed",
  "unknown",
]);

export const DocumentProcessingStatusSourceSchema = z.enum([
  "hatchet",
  "cache",
  "fallback",
]);

export const DocumentProcessingStatusSchema = z.object({
  derivedState: DerivedDocumentStateSchema,
  totalRuns: z.number().int(),
  activeRuns: z.number().int(),
  completedRuns: z.number().int(),
  failedRuns: z.number().int(),
  source: DocumentProcessingStatusSourceSchema,
});

export type DerivedDocumentState = z.infer<typeof DerivedDocumentStateSchema>;
export type DocumentProcessingStatus = z.infer<
  typeof DocumentProcessingStatusSchema
>;

export const isTerminalDerivedState = (state: DerivedDocumentState): boolean =>
  state === "ready" || state === "failed";
